import React from "react";
import { useLocation, Link, Switch, Route } from "react-router-dom";

import { Title, Tab } from "rbx";

import { Booked, Exported, Imported, Verified } from "./routes";

const ELDProcessingPage = () => {
  const location = useLocation();
  return (
    <div>
      <header className="page-head">
        <div className="page-head-start">
          <Title>ELD Processing</Title>
        </div>
      </header>
      <Tab.Group kind="boxed">
        <Tab
          active={new RegExp(/booked$/).test(location.pathname)}
          as={Link}
          tabIndex="-1"
          to="/dispatch/ELD/booked"
        >
          <span>Booked Orders</span>
        </Tab>
        <Tab
          active={location.pathname.includes("exported")}
          as={Link}
          tabIndex="-1"
          to="/dispatch/ELD/exported"
        >
          <span>Exported to ELD</span>
        </Tab>
        <Tab
          active={location.pathname.includes("imported")}
          as={Link}
          tabIndex="-1"
          to="/dispatch/ELD/imported"
        >
          <span>Imported from ELD</span>
        </Tab>
        <Tab
          active={location.pathname.includes("verified")}
          as={Link}
          tabIndex="-1"
          to="/dispatch/ELD/verified"
        >
          <span>Route Verified</span>
        </Tab>
      </Tab.Group>
      <Switch>
        <Route path="/dispatch/ELD/booked">
          <Booked />
        </Route>
        <Route path="/dispatch/ELD/exported">
          <Exported />
        </Route>
        <Route path="/dispatch/ELD/imported">
          <Imported />
        </Route>
        <Route path="/dispatch/ELD/verified">
          <Verified />
        </Route>
      </Switch>
    </div>
  );
};
export default ELDProcessingPage;
